import { Action } from 'redux';
import {
  IAuction,
  IBid,
  IBidCreation,
  IBidPanelRowDetails,
  IBidResult,
  IBook,
} from '../../services';

export enum BidPanelActionEnum {
  ShowBidPanel = '@@bid/SHOW_BID_PANEL',
  HideBidPanel = '@@bid/HIDE_BID_PANEL',
  HideBidPanelWithNoChanges = '@@bid/HIDE_BID_PANEL_WITH_NO_CHANGES',
  SubmitBid = '@@bid/SUBMIT_BID',
  SubmitBidSuccess = '@@bid/SUBMIT_BID_SUCCESS',
  SubmitBidFailed = '@@bid/SUBMIT_BID_FAILED',
  DraftBidFailed = '@@bid/DRAFT_BID_FAILED',
  FetchSubmissionHistory = '@@bid/FETCH_SUBMISSION_HISTORY',
  FetchedSubmissionHistorySuccessfully = '@@bid/FETCHED_SUBMISSION_HISTORY_SUCCESSFULLY',
  ClearSubmissionHistory = '@@bid/CLEAR_SUBMISSION_HISTORY',
}
export interface IBidPanelState {
  showBidPanel?: boolean;
  auction?: IAuction;
  bids?: IBid[];
  originalBids?: IBid[];
  bidSubmissionResponse?: IBidResult;
  loading?: boolean;
  productToUpdate?: IBidPanelRowDetails;
  bidCreation?: IBidCreation;
  status?: string;
  books?: IBook[];
  newBlankBid?: IBid | undefined;
}

export interface IShowBidPanelAction
  extends Action<typeof BidPanelActionEnum.ShowBidPanel> {
  state?: IBidPanelState;
}

export interface IHideBidPanelAction
  extends Action<typeof BidPanelActionEnum.HideBidPanel> {
  state?: IBidPanelState;
}

export interface IHideBidPanelActionWithNoChanges
  extends Action<typeof BidPanelActionEnum.HideBidPanelWithNoChanges> {
  state?: IBidPanelState;
}

export interface ISubmitBidAction
  extends Action<typeof BidPanelActionEnum.SubmitBid> {
  state?: IBidPanelState;
}

export interface ISubmitBidActionSuccessAction
  extends Action<typeof BidPanelActionEnum.SubmitBidSuccess> {
  state?: IBidPanelState;
}

export interface ISubmitBidFailedAction
  extends Action<typeof BidPanelActionEnum.SubmitBidFailed> {
  state?: IBidPanelState;
}

export interface IDraftBidFailedAction
  extends Action<typeof BidPanelActionEnum.DraftBidFailed> {
  state?: IBidPanelState;
}

export type BidPanelActions =
  | IShowBidPanelAction
  | IHideBidPanelAction
  | IHideBidPanelActionWithNoChanges
  | ISubmitBidAction
  | ISubmitBidActionSuccessAction
  | ISubmitBidFailedAction
  | IDraftBidFailedAction;
